define('customPlugins/validationSettings',['knockout', 'knockout.validation'],
    function(ko) {
        'use strict';
        var initalValidationSettings = {
            insertMessages: false,
            decorateInputElement: true,
            decorateElement: true,
            errorMessageClass: 'atn-validation-message',
            errorElementClass: 'atn-validation-element',
            errorsAsTitle: true,
            // errorClass: 'atn-validation-error',
            parseInputAttributes: true,
            //  this must be turned on otherwise whole code will break
            messagesOnModified: true,
            decorateElementOnModified: true,
            messageTemplate: null,
            grouping: {
                deep: false,
                observable: true,
                live: false
            },
            allowHtmlMessages: true,
            registerExtenders: true
        };
        ko.validation.init(initalValidationSettings);

        ko.bindingHandlers.apiFieldErrorMessage = {
            init: function(element) {
                var classNameList = element.className.split(' ');
                classNameList.push(initalValidationSettings.errorMessageClass);
                element.className = classNameList.join(' ');
            },
            update: function(element, valueAccessor) {
                var errorMessage = ko.utils.unwrapObservable(valueAccessor());
                if (errorMessage) {
                    element.innerHTML = errorMessage;
                    element.style.display = '';
                } else {
                    element.innerHTML = '';
                    element.style.display = 'none';
                }
            }
        };

        ko.bindingHandlers.addAPIError = (function() {
            var defautNodeType = 'SPAN';
            return {
                init: init
            };

            function init(element, valueAccessor, allBindings, viewmodel, bindingContext) {
                //  checking if it is a supported kendo widget
                var kendoFilter = ko.fiterKendoComponent(element, allBindings);
                // in case this is a kendo component then
                if (kendoFilter) {
                    element = kendoFilter.element;
                }
                //  adding messageElement
                var messageElement = insertMessageElement(element),
                    value = valueAccessor();
                //  if mesaage field is not available pass error message
                if (!ko.isObservable(value.message)) {
                    throw ('message field has not passed to addAPIError');
                }
                //  applying binding to the node
                ko.applyBindingsToNode(
                    messageElement, {
                        apiFieldErrorMessage: value.message
                    },
                    bindingContext.$data
                );
            }

            function insertMessageElement(element) {
                var span = document.createElement(defautNodeType);
                element.parentNode.insertBefore(span, element.nextSibling);
                return span;
            }
        }());

        ko.bindingHandlers.atnGridAddAPIError = (function() {
            var defautNodeType = 'SPAN';
            var defaultNodeClass = 'atn-validation-span-insert-once';
            return {
                update: update
            };

            function update(element, valueAccessor, allBindings, viewmodel, bindingContext) {
                //  checking if it is a supported kendo widget
                var kendoFilter = ko.fiterKendoComponent(element, allBindings);
                // in case this is a kendo component then
                if (kendoFilter) {
                    element = kendoFilter.element;
                }
                // adding messageElement span
                var messageElement = atnGridInsertMessageElement(element),
                    value = valueAccessor();
                //for if below,if the messageIndex is present,means that the initialized element belongs is inside
                //a grid and addApiError for grid needs to be implemented.
                //if the index inputted is not present in the validation message parent array and hence needs to be created.
                if (value.messageIndex>=0 && value.messageIndex >= value.messageParent().length) {
                    //assuming that messageParent's child objects are single level objects.
                    //replicating the zeroth object skeleton(existing message object) i.e. key-value structure
                    //for the new element added.
                    var newMessageObject = {};
                    _.forEach(value.messageParent()[0], function(value, key) {
                        newMessageObject[key] = ko.observable("");
                    });
                    value.messageParent().push(newMessageObject);
                }
                //if value.messageParent is there,it means that we are using a modified addApiError binding for grid elements.
                if (value.messageParent) {
                    var messageText;
                    if (value.messageParent()[value.messageIndex] && !(value.messageParent()[value.messageIndex][value.messageProperty])) {
                        messageText = '';
                    } else {
                        messageText = value.messageParent()[value.messageIndex][value.messageProperty]();
                    }
                    value.message(messageText);
                }
                //  if mesaage field is not available pass error message
                if (!ko.isObservable(value.message)) {
                    throw ('message field has not passed to addAPIError');
                }
                //  applying binding to the node
                var apiFieldErrorValueAccessor = function() {
                    return value.message;
                };
                if (messageElement.className.indexOf(initalValidationSettings.errorMessageClass) === -1) {
                    var classNameList = messageElement.className.split(' ');
                    classNameList.push(initalValidationSettings.errorMessageClass);
                    messageElement.className = classNameList.join(' ');
                }
                ko.bindingHandlers.apiFieldErrorMessage.update(messageElement, apiFieldErrorValueAccessor, bindingContext.$data);
            }

            function atnGridInsertMessageElement(element) {
                var span = document.createElement(defautNodeType);
                span.className = defaultNodeClass;
                if (element.nextSibling.className.indexOf(defaultNodeClass) === -1) {
                    element.parentNode.insertBefore(span, element.nextSibling);
                } else {
                    span = element.nextSibling;
                }
                return span;
            }
        }());

    });
